import { useCallback } from 'react';

import { useSelector } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { usePush } from '@hh.ru/redux-spa-middleware';

import { getCurrentRouteHrefWithParam } from 'src/app/routesUtils';
import { AreaId } from 'src/types/area';

const useUserArea = () => {
    const { area, status } = useSelectorNonNullable((state) => state.userArea);
    const location = useSelector((state) => state.router.location);
    const push = usePush();

    const onPushQueryArea = useCallback(
        (areaId: AreaId) => {
            push(getCurrentRouteHrefWithParam(location, 'area', areaId), {
                cancelScrollCorrection: true,
            });
        },
        [location, push]
    );

    return {
        area,
        areaId: area.id,
        areaName: area.text,
        areaStatus: status,
        onPushQueryArea,
    };
};

export default useUserArea;
